var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("Benvenuto nel gestionale di amministrazione della PDO")]),_c('p',[_vm._v("Seleziona una pagina qui in parte per accedere a tutte le funzioni.")]),_c('p',[_vm._v("In futuro in questa pagina si potrà vedere un resoconto del funzionamento della piattaforma.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }